import { useState } from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PasswordField = ({ name, id, placeholder }) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="position-relative">
      <Field
        name={name}
        type={showPassword ? 'text' : 'password'}
        className="form-control"
        id={id}
        placeholder={placeholder}
      />
      <button
        type="button"
        className="position-absolute top-0 end-0 h-100 px-2"
        onClick={() => setShowPassword((show) => !show)}
      >
        <i
          className={classNames('text-grey far', {
            'fa-eye': !showPassword,
            'fa-eye-slash': showPassword,
          })}
        />
      </button>
    </div>
  );
};

export default PasswordField;
PasswordField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};
